import { MessageCircle, Users, UserRound } from 'lucide-react';

import type { ChannelType } from '../../api/types';
import { cn } from '../../lib/cn';

/** Channel type this component knows how to render today, plus channels planned for later (§U1). */
export type BadgeChannelType = ChannelType | 'telegram';

const CONFIG: Record<BadgeChannelType, { label: string; icon: typeof Users; className: string }> = {
  vk_group: { label: 'VK-группа', icon: Users, className: 'text-blue-600' },
  vk_personal: { label: 'VK личный', icon: UserRound, className: 'text-indigo-600' },
  // TODO(server): no telegram channel type ships yet — icon slot reserved per §U1/§U8.
  telegram: { label: 'Telegram', icon: MessageCircle, className: 'text-sky-500' },
};

export interface ChannelBadgeProps {
  type: BadgeChannelType;
  className?: string;
  showLabel?: boolean;
}

export function ChannelBadge({ type, className, showLabel = false }: ChannelBadgeProps) {
  const cfg = CONFIG[type];
  const Icon = cfg.icon;
  return (
    <span
      className={cn('inline-flex items-center gap-1', cfg.className, className)}
      title={cfg.label}
      aria-label={cfg.label}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={2.25} />
      {showLabel && <span className="text-xs">{cfg.label}</span>}
    </span>
  );
}
